module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [(_vm.auth.user.authenticated) ? _c('md-sidenav', {
    ref: "main-sidebar",
    staticClass: "main-sidebar md-left md-fixed"
  }, [_c('md-toolbar', {
    staticClass: "vue-material-logo",
    staticStyle: {
      "border-bottom-style": "none"
    },
    attrs: {
      "md-theme": "white"
    }
  }, [_c('router-link', {
    attrs: {
      "exact": "",
      "to": "/landing"
    }
  }, [_c('img', {
    staticStyle: {
      "border-radius": "20px",
      "width": "130px",
      "margin-top": "10px"
    },
    attrs: {
      "src": _vm.logo,
      "alt": "Vue"
    }
  }), _vm._v(" "), _c('span')])], 1), _vm._v(" "), _c('md-list', [(_vm.auth.user.hasRole_keuangan === true) ? _c('div', [_c('md-list-item', {
    staticClass: "pd_center",
    attrs: {
      "md-align": "center"
    }
  }, [_c('div', {
    staticClass: "has-ripple purple",
    attrs: {
      "align": "center"
    }
  }, [_c('md-ink-ripple'), _vm._v(" "), _c('span', [_vm._v(" MENU - KEUANGAN ")])], 1)]), _vm._v(" "), _c('md-list-item', [_c('span', [_c('md-icon', {
    staticClass: "md-primary"
  }, [_vm._v("import_contacts")]), _vm._v("   Reports")], 1), _vm._v(" "), _c('md-list-expand', [_c('md-list', [_c('md-list-item', {
    staticClass: "md-inset"
  }, [_c('router-link', {
    attrs: {
      "exact": "",
      "to": "/reports/dailyheaders"
    }
  }, [_vm._v("Daily Headers")])], 1), _vm._v(" "), _c('md-list-item', {
    staticClass: "md-inset"
  }, [_c('router-link', {
    attrs: {
      "exact": "",
      "to": "/reports/dailydetails"
    }
  }, [_vm._v("Daily Details")])], 1), _vm._v(" "), _c('md-list-item', {
    staticClass: "md-inset"
  }, [_c('router-link', {
    attrs: {
      "exact": "",
      "to": "/reports/finefeedetails"
    }
  }, [_vm._v("Fine Fee Details")])], 1), _vm._v(" "), _c('md-list-item', {
    staticClass: "md-inset"
  }, [_c('router-link', {
    attrs: {
      "exact": "",
      "to": "/reports/parkfeedetails"
    }
  }, [_vm._v("Park Fee Details")])], 1), _vm._v(" "), _c('md-list-item', {
    staticClass: "md-inset"
  }, [_c('router-link', {
    attrs: {
      "exact": "",
      "to": "/reports/itemdetails"
    }
  }, [_vm._v("Items Reported")])], 1), _vm._v(" "), _c('md-list-item', {
    staticClass: "md-inset"
  }, [_c('router-link', {
    attrs: {
      "exact": "",
      "to": "/reports/defectdetails"
    }
  }, [_vm._v("Defects Reported")])], 1)], 1)], 1)], 1)], 1) : (_vm.auth.user.hasRole_adminsystem === true) ? _c('div', [_c('md-list-item', {
    staticClass: "pd_center",
    attrs: {
      "md-align": "center"
    }
  }, [_c('div', {
    staticClass: "has-ripple purple",
    attrs: {
      "align": "center"
    }
  }, [_c('md-ink-ripple'), _vm._v(" "), _c('span', [_vm._v(" MENU - ADMIN SYSTEM ")])], 1)]), _vm._v(" "), _c('md-list-item', [_c('span', [_c('md-icon', {
    staticClass: "md-warn"
  }, [_vm._v("local_library")]), _vm._v("   MASTERS ")], 1), _vm._v(" "), _c('md-list-expand', [_c('md-list', [_c('div', {
    staticStyle: {
      "padding-left": "20px"
    }
  }, [_c('md-list-item', {
    nativeOn: {
      "click": function($event) {
        _vm.redirect('adsys:masters:company', 'MASTER - COMPANIES')
      }
    }
  }, [_c('span', [_c('md-icon', {
    staticClass: "md-primary"
  }, [_vm._v("domain")]), _vm._v("   Companies")], 1)]), _vm._v(" "), _c('md-list-item', {
    nativeOn: {
      "click": function($event) {
        _vm.redirect('adsys:masters:car', 'MASTER - CARS')
      }
    }
  }, [_c('span', [_c('md-icon', {
    staticClass: "md-primary"
  }, [_vm._v("local_taxi")]), _vm._v("   Cars")], 1)]), _vm._v(" "), _c('md-list-item', {
    nativeOn: {
      "click": function($event) {
        _vm.redirect('adsys:masters:color', 'MASTER - COLORS')
      }
    }
  }, [_c('span', [_c('md-icon', {
    staticClass: "md-primary"
  }, [_vm._v("invert_colors")]), _vm._v("   Colors")], 1)]), _vm._v(" "), _c('md-list-item', {
    nativeOn: {
      "click": function($event) {
        _vm.redirect('adsys:masters:monitor', 'MASTER - MONITORS')
      }
    }
  }, [_c('span', [_c('md-icon', {
    staticClass: "md-primary"
  }, [_vm._v("timeline")]), _vm._v("   Monitor")], 1)]), _vm._v(" "), _c('md-list-item', {
    nativeOn: {
      "click": function($event) {
        _vm.redirect('adsys:masters:status', 'MASTER - STATUS')
      }
    }
  }, [_c('span', [_c('md-icon', {
    staticClass: "md-primary"
  }, [_vm._v("notifications_paused")]), _vm._v("   Status")], 1)]), _vm._v(" "), _c('md-list-item', {
    nativeOn: {
      "click": function($event) {
        _vm.redirect('adsys:masters:role', 'MASTER - ROLE')
      }
    }
  }, [_c('span', [_c('md-icon', {
    staticClass: "md-primary"
  }, [_vm._v("group")]), _vm._v("   Role")], 1)]), _vm._v(" "), _c('md-list-item', {
    nativeOn: {
      "click": function($event) {
        _vm.redirect('adsys:masters:postal', 'MASTER - POSTAL CODE')
      }
    }
  }, [_c('span', [_c('md-icon', {
    staticClass: "md-primary"
  }, [_vm._v("local_post_office")]), _vm._v("   Postal Code")], 1)]), _vm._v(" "), _c('md-list-item', {
    nativeOn: {
      "click": function($event) {
        _vm.redirect('adsys:masters:payment_categories', 'MASTER - PAY Category')
      }
    }
  }, [_c('span', [_c('md-icon', {
    staticClass: "md-primary"
  }, [_vm._v("monetization_on")]), _vm._v("   Payment Categories")], 1)]), _vm._v(" "), _c('md-list-item', {
    nativeOn: {
      "click": function($event) {
        _vm.redirect('adsys:masters:defect_master', 'MASTER - Defects')
      }
    }
  }, [_c('span', [_c('md-icon', {
    staticClass: "md-primary"
  }, [_vm._v("healing")]), _vm._v("   Defects")], 1)]), _vm._v(" "), _c('md-list-item', {
    nativeOn: {
      "click": function($event) {
        _vm.redirect('adsys:masters:menu', 'MASTER - MENUS')
      }
    }
  }, [_c('span', [_c('md-icon', {
    staticClass: "md-primary"
  }, [_vm._v("menu")]), _vm._v("   MENU")], 1)])], 1)])], 1)], 1)], 1) : (_vm.auth.user.hasRole_administrative === true) ? _c('div', [_c('md-list-item', {
    staticClass: "pd_center",
    attrs: {
      "md-align": "center"
    }
  }, [_c('div', {
    staticClass: "has-ripple purple",
    attrs: {
      "align": "center"
    }
  }, [_c('md-ink-ripple'), _vm._v(" "), _c('span', [_vm._v(" MENU - RUNNER / CASHIER ")])], 1)]), _vm._v(" "), _c('md-list-item', [_c('md-icon', {
    staticClass: "md-primary"
  }, [_vm._v("directions_car")]), _vm._v(" "), _c('span', [_vm._v(" Status ")]), _vm._v(" "), _c('md-list-expand', [_c('md-list', [_c('md-list-item', {
    staticClass: "md-inset",
    nativeOn: {
      "click": function($event) {
        _vm.redirect('administrative:status_checkin', 'Status Check In')
      }
    }
  }, [_c('span', [_vm._v(" Check In ")])]), _vm._v(" "), _c('md-list-item', {
    staticClass: "md-inset",
    nativeOn: {
      "click": function($event) {
        _vm.redirect('administrative:status_checkout', 'Status Check Out')
      }
    }
  }, [_c('span', [_vm._v(" Check Out ")])]), _vm._v(" "), _c('md-list-item', {
    staticClass: "md-inset",
    nativeOn: {
      "click": function($event) {
        _vm.redirect('administrative:status_all', 'Status All')
      }
    }
  }, [_c('span', [_vm._v(" All Status ")])]), _vm._v(" "), _c('md-list-item', {
    staticClass: "md-inset",
    nativeOn: {
      "click": function($event) {
        _vm.redirect('administrative:history', 'Histories')
      }
    }
  }, [_c('span', [_vm._v(" Log Histories ")])])], 1)], 1)], 1), _vm._v(" "), _c('md-list-item', [_c('md-icon', {
    staticClass: "md-primary"
  }, [_vm._v("trending_up")]), _vm._v(" "), _c('span', [_vm._v(" Reports ")]), _vm._v(" "), _c('md-list-expand', [_c('md-list', [_c('md-list-item', {
    staticClass: "md-inset",
    nativeOn: {
      "click": function($event) {
        _vm.redirect('administrative:status_find', 'Find Data')
      }
    }
  }, [_c('span', [_vm._v(" Find Data ")])]), _vm._v(" "), _c('md-list-item', {
    staticClass: "md-inset",
    nativeOn: {
      "click": function($event) {
        _vm.redirect('administrative:reports_main', 'Main Reports')
      }
    }
  }, [_c('span', [_vm._v(" Main Reports ")])])], 1)], 1)], 1)], 1) : (_vm.auth.user.profile.role.rlms_id === 40) ? _c('div', [_c('md-list-item', {
    nativeOn: {
      "click": function($event) {
        _vm.redirect('keyguard:request', 'Requests')
      }
    }
  }, [_c('md-icon', {
    staticClass: "md-primary"
  }, [_vm._v("notifications")]), _vm._v(" "), _c('span', [_vm._v(" Requests ")])], 1), _vm._v(" "), _c('md-list-item', {
    nativeOn: {
      "click": function($event) {
        _vm.redirect('keyguard:status', 'Status')
      }
    }
  }, [_c('md-icon', {
    staticClass: "md-primary"
  }, [_vm._v("vpn_key")]), _vm._v(" "), _c('span', [_vm._v(" Status ")])], 1), _vm._v(" "), _c('md-list-item', {
    nativeOn: {
      "click": function($event) {
        _vm.redirect('keyguard:history', 'Histories')
      }
    }
  }, [_c('md-icon', {
    staticClass: "md-primary"
  }, [_vm._v("history")]), _vm._v(" "), _c('span', [_vm._v(" Histories ")])], 1), _vm._v(" "), _c('md-list-item', [_c('md-icon', {
    staticClass: "md-primary"
  }, [_vm._v("trending_up")]), _vm._v(" "), _c('span', [_vm._v(" Reports ")]), _vm._v(" "), _c('md-list-expand', [_c('md-list', [_c('md-list-item', {
    staticClass: "md-inset",
    nativeOn: {
      "click": function($event) {
        _vm.redirect('keyguard:reports', 'Reports')
      }
    }
  }, [_c('span', [_vm._v(" Main Reports ")])]), _vm._v(" "), _c('md-list-item', {
    staticClass: "md-inset",
    nativeOn: {
      "click": function($event) {
        _vm.redirect('keyguard:reports', 'Reports')
      }
    }
  }, [_c('span', [_vm._v(" Unclosed Reports ")])])], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('div', [_c('md-list-item', {
    staticClass: "pd_center",
    attrs: {
      "md-align": "center"
    }
  }, [_c('div', {
    staticClass: "has-ripple purple",
    attrs: {
      "align": "center"
    }
  }, [_c('md-ink-ripple'), _vm._v(" "), _c('span', [_vm._v(" USER PREFERENCE ")])], 1)]), _vm._v(" "), _c('md-list-item', {
    nativeOn: {
      "click": function($event) {
        _vm.redirect('maps', 'Maps')
      }
    }
  }, [_c('md-icon', {
    staticClass: "md-primary"
  }, [_vm._v("my_location")]), _vm._v(" "), _c('span', [_vm._v(" Maps ")])], 1), _vm._v(" "), _c('md-list-item', [_c('md-icon', {
    staticClass: "md-warn"
  }, [_vm._v("account_circle")]), _vm._v(" "), _c('span', [_vm._v(" Account ")]), _vm._v(" "), _c('md-list-expand', [_c('md-list', [_c('md-list-item', {
    staticClass: "md-inset",
    nativeOn: {
      "click": function($event) {
        _vm.redirect('preference:site', 'Change Site')
      }
    }
  }, [_c('span', [_vm._v(" Change Site ")])]), _vm._v(" "), _c('md-list-item', {
    staticClass: "md-inset",
    nativeOn: {
      "click": function($event) {
        _vm.redirect('preference:profile', 'Change Profile')
      }
    }
  }, [_c('span', [_vm._v(" Change Profile ")])]), _vm._v(" "), _c('md-list-item', {
    staticClass: "md-inset",
    nativeOn: {
      "click": function($event) {
        _vm.redirect('preference:password', 'Change Password')
      }
    }
  }, [_c('span', [_vm._v(" Change Password ")])]), _vm._v(" "), _c('md-list-item', {
    staticClass: "md-inset",
    nativeOn: {
      "click": function($event) {
        _vm.signout()
      }
    }
  }, [_vm._v("\n                Logout\n              ")])], 1)], 1)], 1)], 1)])], 1) : (!_vm.auth.user.authenticated) ? _c('md-sidenav', {
    ref: "main-sidebar",
    staticClass: "main-sidebar md-left md-fixed"
  }, [_c('md-toolbar', {
    staticClass: "vue-material-logo",
    staticStyle: {
      "border": "0px",
      "top": "50%",
      "position": "relative",
      "transform": "translateY(-50%)"
    },
    attrs: {
      "md-theme": "white"
    }
  }, [_c('router-link', {
    attrs: {
      "exact": "",
      "to": "/"
    }
  }, [_c('md-card-media', {
    attrs: {
      "md-with-hover": ""
    }
  }, [_c('md-ink-ripple'), _vm._v(" "), _c('img', {
    staticClass: "md-raised",
    staticStyle: {
      "border-radius": "40px"
    },
    attrs: {
      "src": _vm.logo,
      "alt": "Vue"
    }
  })], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.auth.user.authenticated) ? _c('div', [_c('md-whiteframe', {
    staticClass: "main-header",
    attrs: {
      "md-tag": "md-toolbar",
      "md-elevation": "1"
    }
  }, [_c('md-button', {
    staticClass: "md-icon-button nav-trigger",
    nativeOn: {
      "click": function($event) {
        _vm.toggleSidenav($event)
      }
    }
  }, [_c('md-icon', [_vm._v("menu")])], 1), _vm._v(" "), _c('div', {
    staticClass: "md-title"
  }, [_vm._v("     " + _vm._s(_vm.pageTitle))]), _vm._v(" "), _c('md-button', {
    staticClass: "md-icon-button",
    attrs: {
      "rel": "noopener"
    },
    nativeOn: {
      "click": function($event) {
        _vm.signout()
      }
    }
  }, [_c('md-icon', [_vm._v("exit_to_app")])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "md-router",
      "appear": ""
    }
  }, [_c('router-view')], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3b75fe40!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 549
// module chunks = 83